import { render, staticRenderFns } from "./VerticalMenu.vue?vue&type=template&id=003948ab&scoped=true"
import script from "./VerticalMenu.vue?vue&type=script&lang=js"
export * from "./VerticalMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003948ab",
  null
  
)

export default component.exports